<template>
  <div class="home">
    <h1 class="seo-title">{{ $t('app.h1') }}</h1>
    <h2 class="seo-title">Купить робуксы легко!</h2>
    <div class="change-password" v-if="$store.state.change_password"><ChangePassword /></div>
    <div class="wrapper">
      <div class="f-block">
        <Navigation />
        <MethodChoose />
      </div>
    </div>
    <div class="info-wrapper">
      <Faq />
      <FishDivider />
      <Help />
      <img src="@/assets/images/Home/bottom-bg.svg" class="info-wrapper__bottom" alt="bottom-bg" />
    </div>
    <Footer />
  </div>
</template>

<script>
import Navigation from '@/components/Navigation/Navigation'
import Faq from '@/components/FAQ/Faq'
import Help from '@/components/Help/Help'
import Footer from '@/components/Footer/Footer'
import ChangePassword from '@/components/ChangePassword/ChangePassword'
import FishDivider from '@/components/FishDivider/FishDivider.vue'
import MethodChoose from '@/components/MethodChoose/MethodChoose.vue'

export default {
  name: 'Home',

  components: {
    MethodChoose,
    FishDivider,
    Navigation,
    Faq,
    Help,
    Footer,
    ChangePassword
  }
}
</script>

<style scoped lang="scss">
@import './home';
</style>
